import React from "react";
import CollapsableWrapper from "../CollapsableWrapper/CollapsableWrapper";
import BasicUserInformation from "../BasicUserInformation/BasicUserInformation";
import AddressData from "../AddressData/AddressData";
import MappedRegistrationComponent from "../MappedRegistrationComponent/MappedRegistrationComponent";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import { Spinner } from "react-bootstrap";

const EntryForm9 = (props) => {
  const { reviserRegistration } = props.parentState.newFormData;

  const { revReg3rdParty } = props.parentState.newFormData;
  const mappedRevReg3rdParty = revReg3rdParty.map((element,index) => {
    return (
      <CollapsableWrapper clickText="Registracija ovlaštenog revizora kod nadležnog tijela drugih država članica i kao revizora kod nadležnih tijela u trećim zemljama">
        <MappedRegistrationComponent
          {...props}
          id={element.id}
          idZaBtn={index}
          onChange={props.mappedUserInputHandler}
          inputValue={props.parentState.newFormData.revReg3rdParty}
          group="revReg3rdParty"
        />
      </CollapsableWrapper>
    );
  });

  const disableCounty = props.parentState.newFormData.address.sifDrzave
    ? false
    : true;
  const disableCity = props.parentState.newFormData.address.sifZupanije
    ? false
    : true;
  const disableDistrict = props.parentState.newFormData.address.sifGrdOpc
    ? false
    : true;

  return (
    <>
      <CollapsableWrapper clickText="Osnovni podaci">
        <BasicUserInformation
          stranac
          disabled={
            props.parentState.newFormData.oznDokumenta.oznDokumenta !== null &&
            props.parentState.update &&
            props.parentState.newFormData.userData.oznAkt
          }
          required
          {...props}
        />
      </CollapsableWrapper>
      <CollapsableWrapper
        clickText={"Podaci o adresi i registraciji u Hrvatskoj"}
      >
        <AddressData
          disableCountry
          permitDateLabel="Datum registracije"
          permitNumberLabel="Broj registracije"
          required
          requiredKbr
          requiredBrPoste
          requiredRegistration
          disableDistrict={disableDistrict}
          disableCity={disableCity}
          disableCounty={disableCounty}
          {...props}
        />
      </CollapsableWrapper>
      {/* {mappedReviserData} */}
      {mappedRevReg3rdParty}
      <br></br>
      <div className="invert">
        {props.loader ? (
          <ButtonComponent disabled>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Spremanje...
          </ButtonComponent>
        ) : (
          <ButtonComponent onClick={props.submitHandler}>
            {props.parentState.update ? "Spremi promjene" : "Unos u registar"}
          </ButtonComponent>
        )}{" "}
      </div>
    </>
  );
};

export default EntryForm9;
